import React, {createContext, useState, useContext, ReactNode, useEffect} from 'react';

export interface EditorKeyMoment {
    key_moment_id: string;
    key_moment_cut_id: string;
}

interface EditorKeyMomentsContextProps {
    editorKeyMoments: EditorKeyMoment[];
    setEditorKeyMoments: React.Dispatch<React.SetStateAction<EditorKeyMoment[]>>;
    addEditorKeyMoment: (moment: EditorKeyMoment) => void;
    removeEditorKeyMoment: (cut_id: string) => void;
    updateEditorKeyMoments: (moment: EditorKeyMoment[]) => void;
    toggleEditorKeyMoment: (moment: EditorKeyMoment) => void
}

const EditorKeyMomentsContext = createContext<EditorKeyMomentsContextProps | undefined>(undefined);

interface ProviderProps {
    children: ReactNode;
}

export const EditorKeyMomentsProvider: React.FC<ProviderProps> = ({ children }) => {
    const [editorKeyMoments, setEditorKeyMoments] = useState<EditorKeyMoment[]>([]);

    const addEditorKeyMoment = (newMoment: EditorKeyMoment) => {
        setEditorKeyMoments((prev) => [...prev, newMoment]);
    };

    const removeEditorKeyMoment = (cut_id: string) => {
        setEditorKeyMoments((prev) => prev.filter((m) => m.key_moment_cut_id !== cut_id));
    };

    const toggleEditorKeyMoment = (editorKeyMoment: EditorKeyMoment) => {
        setEditorKeyMoments(prev => {
            const exists = prev.some(kme => kme.key_moment_id === editorKeyMoment.key_moment_id);
            if (exists) {
                return prev.filter(kme => kme.key_moment_id !== editorKeyMoment.key_moment_id);
            } else {
                return [...prev, editorKeyMoment];
            }
        });
    };

    const updateEditorKeyMoments = (newEditorKeyMoments: EditorKeyMoment[]) => {
        const prevEditorKeyMoments = [...editorKeyMoments];
        for (const newEditorKeyMoment of newEditorKeyMoments){
            const kmTarget = prevEditorKeyMoments.find(ekm => ekm.key_moment_id === newEditorKeyMoment.key_moment_id)
            if(kmTarget){
                kmTarget.key_moment_cut_id = newEditorKeyMoment.key_moment_cut_id;
            }else{
                console.error("No key moment with id", newEditorKeyMoment.key_moment_id, "in editor key moments")
            }
        }
        setEditorKeyMoments(prevEditorKeyMoments)
    }

    return (
        <EditorKeyMomentsContext.Provider value={{ toggleEditorKeyMoment, editorKeyMoments, removeEditorKeyMoment, addEditorKeyMoment, setEditorKeyMoments, updateEditorKeyMoments}}>
            {children}
        </EditorKeyMomentsContext.Provider>
    );
};

export const useEditorKeyMoments = (): EditorKeyMomentsContextProps => {
    const context = useContext(EditorKeyMomentsContext);

    if (!context) {
        throw new Error('useKeyMoments deve essere utilizzato all\'interno di un KeyMomentsProvider');
    }

    return context;
};